module.exports = __webpack_public_path__ + "static/media/peak_equ.9ce30276.png";